import { useEffect, useRef } from 'react';

/**
 * Calls `reset` when the page is restored from the browser's back/forward
 * cache (e.g. after the user navigates back from a redirect triggered while
 * some UI was mid-flight, such as a loading spinner), since bfcache restores
 * the page verbatim, including any state that was captured while pending.
 */
export const useResetOnBfcacheRestore = (reset: () => void) => {
  const resetRef = useRef(reset);
  resetRef.current = reset;

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        resetRef.current();
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);
};
